CellContentModeDialog = require 'components/etd/etd_header_cell_content_mode_dialog'
CollapsibleWithControls = require 'components/common/collapsible_with_controls'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
EtdActions = require 'actions/etd_actions'
etdHelper = require 'lib/etd_helper'
etdHeaderHelper = require 'lib/etd_header_helper'
HeaderRow = require 'components/etd/etd_header_row'
mediator = require 'mediator'
Modal = require 'components/common/modal'
OutcomesThresholdTable = require 'components/etd/outcomes_threshold_table'
ProgressSelect = require 'components/evidence_syntheses/progress_select'
Router = require 'router'
Translation = require 'components/mixins/translation'

Header = createReactClass

  displayName: 'EtdHeaderComponent'
  mixins: [CustomRenderMixin, Translation('')]

  propTypes:
    headerSections: PropTypes.object.isRequired
    headerTransitionEnd: PropTypes.func
    type: PropTypes.oneOf(
      ['overarching', 'keyMessages', 'regular', 'qualityIndicators', 'mdgRecommendation']
    ).isRequired
    keyMessagesData: PropTypes.instanceOf(Immutable.Map)
    overarchingQuestionData: PropTypes.instanceOf(Immutable.Map).isRequired
    questions: PropTypes.oneOfType([
      PropTypes.instanceOf(Immutable.OrderedMap),
      PropTypes.instanceOf(Immutable.Map)]
    )

  getDefaultProps: ->
    keyMessagesData: Immutable.Map()
    questions: Immutable.Map()

  getInitialState: ->
    cellToSwitchContentMode: null

  enableEdit: ->
    { type } = @props
    questionData = @_getQuestionData()
    if type is 'overarching'
      route = Router::getProjectRelativeUrl("/overarching-questions/#{questionData.get('_id')}/edit")
      mediator.publish '!router:route', route
    else
      EtdActions.enableHeaderEdit()

  getHeaderControls: ->
    isEditing = @_isEditing()
    [
      name: if isEditing then 'save' else 'edit'
      handler: if isEditing then @handleSave else @enableEdit
    ]

  handleCollapse: ->
    @handleSave()
    @toggleExpand()

  handleSave: ->
    if @_isEditing()
      @_saveHeaderRowsContent()
      _.defer -> EtdActions.saveHeaderData()

  _saveHeaderRowsContent: ->
    _.each @refs, (ref) ->
      ref?.saveContent?()

  showContentModeSwitchModal: (sectionId) ->
    @setState cellToSwitchContentMode: sectionId

  hideContentModeSwitchModal: ->
    @setState cellToSwitchContentMode: null

  handleContentSwitchDecision: (accepted) ->
    sectionId = @state.cellToSwitchContentMode
    @hideContentModeSwitchModal()
    if accepted
      # update cell html with the default content if new mode is manual (that is current
      # mode is auto)
      if @_isAutoContentCell sectionId
        EtdActions.updateHeaderFieldContent {
          sectionId,
          content: @_getQuestionAttrContent sectionId
        }
      EtdActions.switchCellContentMode(sectionId)
    else
      @refs[sectionId].focusEditCell()

  toggleExpand: ->
    EtdActions.toggleHeader()

  _isDxQuestionWithoutComparatorTest: ->
    etdHeaderHelper.isDxQuestionWithoutComparatorTest
      question: @props.question
      questionType: @props.questionType

  _getQuestionAttrName: (sectionId) ->
    etdHeaderHelper.getQuestionAttrName sectionId

  _getCellContent: (sectionId) ->
    etdHeaderHelper.getCellContent _.extend {}, @props, { sectionId }

  _getCellContentComponent: (sectionId) ->
    return null unless sectionId in ['mainOutcomes', 'outcomes']
    return null unless @_hasAutoContentGenerationOn(sectionId) or sectionId is 'outcomes'
    return null if @props.type in ['overarching', 'keyMessages']
    return null unless etdHelper.shouldRenderOutcomesThresholdTable @props.question

    <OutcomesThresholdTable outcomes={@props.question.get('outcomes')} />

  _getQuestionData: (type) ->
    { type, overarchingQuestionData, keyMessagesData } = @props
    switch type
      when 'overarching' then overarchingQuestionData
      when 'keyMessages' then keyMessagesData

  _getQuestionAttrContent: (sectionId) ->
    etdHeaderHelper.getQuestionAttrContent _.extend {}, @props, { sectionId }

  headerRow: (sectionData, sectionId) ->
    return null unless sectionData
    # don't render "comparison" section if this is a dx question without comparator test
    return null if sectionId is 'comparison' and @_isDxQuestionWithoutComparatorTest()

    headerRowProps = @_getHeaderRowProps(sectionData, sectionId)

    <HeaderRow {...headerRowProps} />

  _getHeaderRowProps: (sectionData, sectionId) ->
    return {
      cellContent: @_getCellContent(sectionId)
      cellContentComponent: @_getCellContentComponent(sectionId)
      cellLabel: sectionData.get 'name'
      hasSwitchButton: @_isAutoContentCell sectionId
      inAutoMode: @_hasAutoContentGenerationOn sectionId
      isEditing: @_isEditing()
      key: sectionId
      questionType: @props.questionType
      ref: sectionId
      renderMode: @props.renderMode
      sectionId: sectionId
      showContentModeSwitchModal: @showContentModeSwitchModal.bind this, sectionId
      updateHeaderFieldContent: EtdActions.updateHeaderFieldContent
    }

  _isAutoContentCell: (sectionId) ->
    etdHeaderHelper.isAutoContentCell sectionId

  _hasAutoContentGenerationOn: (sectionId) ->
    etdHeaderHelper.hasAutoContentGenerationOn _.extend {}, @props, { sectionId }

  _getQuestionText: ->
    { type } = @props
    if type is 'overarching'
      etdHelper.getOverarchingQuestionText @props.overarchingQuestionData
    else
      etdHelper.getQuestionText @props.question, @props.renderMode

  _isInPrintoutMode: ->
    @props.renderMode is 'printout'

  _isEditing: ->
    if @_isInPrintoutMode() then false else @props.isHeaderEditing

  componentWillUnmount: ->
    if @_isEditing()
      @handleSave()
      mediator.dialogs.success $.t 'messages.changes_saved'

  render: ->
    # return if question hasn't been fetched yet since call to it is async. Later on when Question
    # store is updated render func will re-run and render the content
    {
      headerSections
      headerTransitionEnd
      isHeaderExpanded
      overarchingQuestionData
      projectFromOrganization
      question
      questionStatuses
    } = @props

    return null if question.isEmpty() and overarchingQuestionData.isEmpty()

    isMdgFeaturesOn = mediator.services.switches.isServerSwitchOn('mdgFeatures')

    <div className='recommendations-header'>
      {if @_isInPrintoutMode()
        <table>
          <tbody>
            <tr className="title">
              <td colSpan="2">
                <h1 className='title'>
                  {@i18n "/es:question.question"}
                </h1>
              </td>
            </tr>
            <tr>
              <td className="question" colSpan="2">
                <p dangerouslySetInnerHTML={{__html: @_getQuestionText()}}/>
              </td>
            </tr>
            {headerSections.map(@headerRow).toList()}
          </tbody>
        </table>
      else
        <CollapsibleWithControls
          isExpanded={isHeaderExpanded}
          controls={@getHeaderControls()}
          onExpand={@toggleExpand}
          onCollapse={@handleCollapse}
          withTogglableCaption
          onTransitionEnd={headerTransitionEnd}
        >
          <div className='title-container'>
            <h1 className='title'>
              {@i18n "/es:question.question"}
            </h1>
            {projectFromOrganization and not isMdgFeaturesOn and
              <ProgressSelect
                groupKey={'recommendationStatus'}
                questionId={question.get('_id')}
                questionStatuses={questionStatuses}
              />
            }
          </div>
          <table>
            <colgroup>
              <col className="c-1" />
              <col className="c-2" />
              <col className="right-button" />
            </colgroup>
            <tbody>
              <tr>
                <td
                  className="question"
                  colSpan="2"
                  dangerouslySetInnerHTML={{__html: @_getQuestionText()}}
                />
              </tr>
              {headerSections.map(@headerRow).toList()}
            </tbody>
          </table>
        </CollapsibleWithControls>
      }
      {
        unless @_isInPrintoutMode()
          <Modal
            modalSize="standard"
            className="content-mode-switch-modal"
            isOpen={@state.cellToSwitchContentMode isnt null}
            closeButton={true}
            onClose={@hideContentModeSwitchModal}
          >
            <CellContentModeDialog
              currentlyInAutoMode={@_hasAutoContentGenerationOn(@state.cellToSwitchContentMode)}
              handleInput={@handleContentSwitchDecision}
            />
          </Modal>
      }
    </div>

module.exports = Header
